import { IMediaModel } from "@nf/common";

import styles from "./MediaDescription.module.scss";

interface MediaDescriptionProps {
  media: IMediaModel;
}

const MediaDescription = ({ media }: MediaDescriptionProps) => {
  return (
    <p className={styles.description}>
      {media.Description || media.LongDescription}
    </p>
  );
};

export default MediaDescription;
